import {Post} from '../types';
import {dayLabel} from './when';

export interface DayGroup {
    /** "YYYY-MM-DD" */
    day: string;
    label: string;
    posts: Post[];
}

/** Groups an already-ordered feed by the local day the gardener meant (whenLocal), keeping order. */
export function groupByDay(posts: Post[], today: string): DayGroup[] {
    const groups: DayGroup[] = [];
    for (const post of posts) {
        const day = post.whenLocal.slice(0, 10);
        const last = groups[groups.length - 1];
        if (last && last.day === day) {
            last.posts.push(post);
        } else {
            groups.push({day, label: dayLabel(day, today), posts: [post]});
        }
    }
    return groups;
}
